import { useAuth } from './use-auth';

/**
 * Ronda E de L7 (T16-4): si la persona puede ABRIR un módulo: lo tiene y no está
 * «Bloqueado» para su rol (la misma cuenta que `ProtectedRoute`). Un enlace a un
 * módulo que no abre lleva a la puerta cerrada: mejor decir dónde se hace.
 */
export function useAbreElModulo(menuKey: string): boolean {
  const { canSeeMenu, isModuleLocked } = useAuth();
  return canSeeMenu(menuKey) && !isModuleLocked(menuKey);
}
